// src/pages/blog/BlogPage.js
import { useState } from 'react';
import { useQuery } from 'react-query';
import { fetchArticles, fetchCategories } from '../../services/api';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeader, CategoryFilter, SkeletonGrid, ErrorBox, EmptyState } from '../../components/ui';
import ArticleCard from '../../components/ui/ArticleCard';
import styles from './BlogPage.module.css';

export default function BlogPage() {
  const { ui, lang } = useLang();
  const [activeCategory, setActiveCategory] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const { data: categories = [] } = useQuery('categories', fetchCategories);

  const params = {
    page,
    ...(activeCategory && { 'category__slug': activeCategory }),
    ...(search && { search }),
  };

  const { data, isLoading, isError, refetch } = useQuery(
    ['articles', params],
    () => fetchArticles(params),
    { keepPreviousData: true }
  );

  const articles = data?.results || data || [];
  const totalPages = data?.count ? Math.ceil(data.count / 12) : 1;

  const handleCategory = (slug) => { setActiveCategory(slug); setPage(1); };

  return (
    <main className={styles.main}>
      <SectionHeader
        badge={ui('✦ مقالات', '✦ Articles')}
        title={ui('دانش و الهام از دنیای شمع', 'Candle Knowledge & Inspiration')}
      />

      <div className={styles.searchWrap}>
        <input
          type="text"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          placeholder={ui('جستجو در مقالات...', 'Search articles...')}
          className={styles.search}
        />
      </div>

      <CategoryFilter categories={categories} active={activeCategory} onSelect={handleCategory} lang={lang} />

      {isLoading && <SkeletonGrid count={6} height={320} />}
      {isError && <ErrorBox onRetry={refetch} />}
      {!isLoading && !isError && articles.length === 0 && (
        <EmptyState icon="📖" fa="مقاله‌ای یافت نشد" en="No articles found" lang={lang} />
      )}
      {!isLoading && !isError && articles.length > 0 && (
        <div className={styles.grid}>
          {articles.map((article) => <ArticleCard key={article.id} article={article} />)}
        </div>
      )}

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button className="btn-secondary" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
            {ui('قبلی', 'Prev')}
          </button>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.88rem' }}>{page} / {totalPages}</span>
          <button className="btn-secondary" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages}>
            {ui('بعدی', 'Next')}
          </button>
        </div>
      )}
    </main>
  );
}
